import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { CryptoJsService } from './crypto-js.service';
import { IpAddressService } from './ip-address.service';

@Injectable({
  providedIn: 'root'
})
export class ActivityRecordService {

  loginId: any;
  actionType: any;
  specificId: any;
  dateTime: any;
  status: any;
  args: any;

  ipAddress: any = '000.000.000';


  constructor(
    private ipService: IpAddressService, 
    private authenticationService : AuthenticationService, 
    private messageService: MessageService,
    private cryptoJs: CryptoJsService
    ) {}

  ngOnInit()
  {
    
  }

  activityRecord(loginId, actionType, specificId, dateTime, status, ...args){
    this.getIP();
   
    this.loginId = loginId;
    this.actionType = actionType;
    this.specificId = specificId;
    this.dateTime = dateTime;
    this.status = status;
    this.args = args;
  }

  activityDataTimeRecord(reqBody) {
    this.authenticationService
    .activityDataTimeRecord(reqBody)
    .pipe(first())
    .subscribe({
      next: (data) => {
        // this.messageService.add({
        //   severity: 'info',
        //   summary: 'Activity Recorded',
        //   detail: data,
        // });

      },
      error: (err) => {
        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Error Message',
        //   detail: err,
        // });
      },
    });
  }


  getIP() {
    this.ipService.getIPAddress().subscribe({
      next: (res) =>{
        // console.log("responseee", res)
        this.ipAddress = res['ip'];
        // console.log("ipAddresss", this.ipAddress);
      },
      error: () => {

      },
      complete: () => {
        let reqBody ={
          LoginID: this.loginId ? this.loginId: '',
          ActionType: this.actionType ? this.actionType: '',
          SpecificId: this.specificId ? this.specificId: '',
          NetworkId: this.ipAddress,
          OccurrenceDateTime: this.dateTime,
          Status: this.status? this.status:'',
          RequestPayload: this.args[0]? JSON.stringify(this.args[0]):''
        }

        this.activityDataTimeRecord(reqBody);
      }
    })  
  }

}